export const publicPath = '/';

export const routeCodes = {
  DASHBOARD: publicPath,
  LOGIN: `${publicPath}login`,
  TRENDING: `${publicPath}trending`,
  FILM: `${publicPath}film`,
  LISTS: `${publicPath}lists`,
  CREATE_LIST: `${publicPath}create-list`,
  WATCHLIST: `${publicPath}watchlist`,
  FAVORITES: `${publicPath}favorites`,
  RECOMMENDATIONS: `${publicPath}recommendations`,
  EDIT_LIST: `${publicPath}edit-list`,
};
